import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedQueueCreateRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-queue-create',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/queues/custom/new',
	query: ['parentId?'],
	exact: true,
};
